export const getInstallEndingIsNotifiedByInstallType = ((type) => {
    return localStorage.getItem(`${type}InstallsNotification`);
});

export const setInstallTypeIsNotified = (type) => {
    localStorage.setItem(`${type}InstallsNotification`, 'true');
}

export const removeAllInstallsIsNotified = () => {
    localStorage.removeItem('iosInstallsNotification');
    localStorage.removeItem('pwaInstallsNotification');
    localStorage.removeItem('androidInstallsNotification');
}